import { render } from "./FacebookPosts.vue?vue&type=template&id=eaa95b16&lang=true"
import script from "./FacebookPosts.vue?vue&type=script&lang=js"
export * from "./FacebookPosts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__